<template>
  <div class="chat-item-file my-1" :class="{me: isMine}">
    <small v-if="isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
    {{ value.message | log }}
    <span class="px-2 py-2 pointer" @click.prevent="openFile">
      <div class="image"
      v-if="value.message.mime_type === 'image/jpeg'"
      :style="{backgroundImage: `url(${url})`}">
      </div>
      <div v-else class="file">
        <FileIcon></FileIcon>
      </div>
      <div>{{ value.message.name }}</div>
    </span>
    <small v-if="!isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FileIcon from '@/components/Icons/File'
export default {
  components: {
    FileIcon
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authToken: 'auth/token'
    }),
    url () {
      return `${this.staticUrl}/api/chat-spaces/${this.value.chat_space_id}/files/${this.value.message.id}?token=${this.authToken}`
    }
  },
  methods: {
    openFile () {
      window.open(this.url, '_blank')
    }
  }
}
</script>
<style lang="scss">
.chat-item-file {
  width: 100%;
  .image {
    min-width: 175px;
    width: 100%;
    padding-top: 70%;
    background-size: cover;
    background-position: center;
  }
  .file {
    svg {
      min-width: 175px;
      width: 100%;
      max-width: 150px;
    }
  }
  span {
    background-color: #eee;
    border-radius: 0.9em;
    font-size: 0.8em;
    font-weight: normal;
    display: inline-block;
  }
  small {
    font-size: 0.65em;
  }
  &.me {
    text-align: right;
    span {
      background-color: #3c88ff;
      color: #fff;
    }
  }
}
</style>
